"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class ProjectApiClient {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }

  async getPowerBiReportAsPng(projectId, reportId) {
    const relativePath = `/projects/${projectId}/powerBiReports/${reportId}/AsPng`;
    const response = await this.httpClient.get({
      relativePath
    });
    return response.data.data;
  }

  async getPowerBiReportPageAsPng(projectId, reportId, pageName) {
    const relativePath = `/projects/${projectId}/powerBiReports/${reportId}/${pageName}/AsPng`;
    const response = await this.httpClient.get({
      relativePath
    });
    return response.data.data;
  }

  async getLibraryItemData({
    projectId,
    libraryItemId,
    contentThreadId,
    accept = 'text/html'
  }) {
    const queryParams = contentThreadId ? `?contentThreadId=${contentThreadId}` : '';
    const relativePath = `/projects/${projectId}/LibraryItems/${libraryItemId}${queryParams}`;
    const response = await this.httpClient.get({
      relativePath,
      headers: {
        Accept: accept
      }
    });
    return response.data;
  }

  async getLibraryItemDataForExcelAddin({
    projectId,
    libraryItemId
  }) {
    const relativePath = `/projects/${projectId}/LibraryItems/forExcelAddin/${libraryItemId}`;
    const response = await this.httpClient.get({
      relativePath
    });
    return response.data;
  }

  async getStructuredAnalysisLibraryItems({
    projectId,
    documentCode,
    contentThreadId,
    contentVersionNumber
  }) {
    const contentThreadIdQueryParam = contentThreadId ? `contentThreadId=${contentThreadId}` : '';
    const contentVersionNumberQueryParam = contentVersionNumber ? `contentVersionNumber=${contentVersionNumber}` : '';
    const paramStrings = [contentThreadIdQueryParam, contentVersionNumberQueryParam].filter(p => p !== '');
    let queryParams = '';

    if (paramStrings.length > 0) {
      queryParams = `?${paramStrings.join('&')}`;
    }

    const relativePath = `/projects/${projectId}/StructuredAnalysisDocuments/${documentCode}/LibraryItems/search${queryParams}`;
    const response = await this.httpClient.get({
      relativePath
    });
    return response.data;
  }

  async postChart({
    projectId,
    chartData
  }) {
    return postLibraryItem(this.httpClient, projectId, chartData, 'chart');
  }

  async postNamedRange({
    projectId,
    namedRangeData
  }) {
    return postLibraryItem(this.httpClient, projectId, namedRangeData, 'namedRange');
  }

}

exports.default = ProjectApiClient;

const postLibraryItem = async (httpClient, projectId, data, type) => {
  const relativePath = `/projects/${projectId}/LibraryItems/${type}`;
  const response = await httpClient.post({
    relativePath,
    data
  });
  return response.data;
};